const env = {
    locale: 'en-gb'
};

export default env;